import Vue from 'vue'
import { stringify } from 'query-string'
const message = new Vue()
const CodeEnum = {
  // 成功
  SUCCESS: '200',
  // 未登录h
  NOT_LOGIN: '100'
  // 验证码失效
}
export const post = function (url, params, opts = {}) {
  opts['headers'] = getHeaders(opts['headers'])
  if (!(params instanceof FormData)) {
    opts['headers']['Content-Type'] = 'application/json;charset=UTF-8'
  }
  return Vue.http.post(url, params, opts).then(result, err)
}

export const put = function (url, params, opts = {}) {
  opts['headers'] = getHeaders(opts['headers'])
  if (!(params instanceof FormData)) {
    opts['headers']['Content-Type'] = 'application/json;charset=UTF-8'
  }
  return Vue.http.put(url, params, opts).then(result, err)
}

export const get = function (url, params, opts = {}) {
  opts['headers'] = getHeaders(opts['headers'])
  return Vue.http.get(url, Object.assign({}, { params: params }, opts)).then(result, err)
}

export const del = function (url, params, opts = {}) {
  opts['headers'] = getHeaders(opts['headers'])
  return Vue.http.delete(url, Object.assign({}, { params: params }, opts)).then(result, err)
}

const methods = { post, put, get, del }

let adapterResponse = response => {
  const path = response.config.url
  let data
  if (path.indexOf('/api') === 0) {
    data = response.data
    return {
      success: data.errcode === 0,
      notLogin: data.errcode === 100,
      msg: data.devMsg || data.msg || data.message,
      responseCode: ''
    }
  } else {
    data = response.data.data || response.data
    const responseCode = (data && data.info && data.info.toString())
    return {
      success: responseCode === CodeEnum.SUCCESS,
      notLogin: responseCode === CodeEnum.NOT_LOGIN,
      responseCode,
      msg: data.msg || data.message
    }
  }
}

let getHeaders = (data = {}) => {
  return data
}

let result = response => {
  // if (`${response.status}`.charAt(0) !== '2') {
  //   message.$message.error('服务器异常，请稍后重试')
  //   // eslint-disable-next-line prefer-promise-reject-errors
  //   return Promise.reject(null)
  // }
  if (response.status === 404) {
    message.$message.warn('接口找不到')
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(null)
  }
  if (response.status === 601) {
    message.$message.warn('网络请求超时，稍后重试')
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(null)
  }
  const errdata = response.data
  // console.log('MMMMMM', errdata)
  if (errdata.errcode === 500) {
    message.$message.error('服务端异常，请稍后重试')
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(null)
  }
  if (errdata.code === 'not_found') {
    message.$message.error('服务接口找不到')
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(null)
  }
  var data = response.data.data || response.data
  // 处理老的接口兼容
  const { responseCode, success, msg, errcode, devMsg, notLogin } = adapterResponse(response)
  // console.log(adapterResponse(response), '---', data)
  // 老的无为editor接口
  // 未登录 自动跳转登录页面
  if (notLogin || response.data.status === 401) {
    window.location.href = `${process.env.LOGIN_URL}?${stringify({
      url: window.location.href,
      type: ''
    })}`
  }
  if (responseCode === '10000') {
    message.$message.error('用户已被删除')
    window.location.href = `${process.env.LOGIN_URL}`
    return Promise.reject(data)
    // 服务器异常的情况下
  }
  if (success || errcode === 0) {
    return Promise.resolve(data)
    // 服务器异常的情况下
  } else if (data.info === CodeEnum.NOT_LOGIN) {
    // 其他异常处理
  } else {
    if (msg) {
      message.$message.error(msg)
        return Promise.reject(null) // eslint-disable-line
    } else {
      let errData = Object.assign({}, data, {
        code: response.data.code,
        message: response.data.message || devMsg || '服务器错误！'
      })
      return Promise.reject(errData)
    }
  }
}
let err = response => {
  // 处理http状态码
  if (`${response.status}`.charAt(0) === '4') {
    return Promise.reject({ message: '请求资源不存在' }) // eslint-disable-line
  } else if (`${response.status}`.charAt(0) === '5') {
    return Promise.reject({ message: '服务器繁忙，请稍后再试' }) // eslint-disable-line
  }
}

const plugin = (Vue, opts) => {
  Object.keys(methods).map(item => {
    if (!Vue.prototype[`$${item}`]) {
      Vue.prototype[`$${item}`] = methods[item]
    }
  })

  if (!Vue.prototype.$report) {
    Vue.prototype.$report = function (opts = {}, isSendBeacon = false) {
      if (!opts.aliSLS) {
        opts.aliSLS = {
          project: 'hex',
          host: 'cn-beijing.log.aliyuncs.com',
          logstore: 'editor-front'
        }
      }
      const { project, host, logstore } = opts.aliSLS
      delete opts.aliSLS
      const apiVersion = '0.6.0'
      let url = `//${project}.${host}/logstores/${logstore}/track?APIVersion=${apiVersion}`
      opts._env = process.env.NODE_ENV || 'production'
      opts._os = window.navigator.userAgent
      opts._host = window.location.hostname
      opts._type = 'wuwei-front'

      const logs = JSON.stringify(opts)
      opts.__topic__ = 'hex_editor'
      opts.__source__ = window.navigator.userAgent
      const parsedLogs = JSON.parse(logs)
      opts.__logs__ = [parsedLogs]
      for (let k in parsedLogs) {
        delete opts[k]
      }
      // TODO: 根据需求分类处理
      opts.__tags__ = {
        'tag': 'wuwei'
      }
      if (isSendBeacon) {
        // navigator.sendBeacon not support custom headers, so please isSendBeacon false
        if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
          return navigator.sendBeacon(url, new Blob([JSON.stringify(opts)], {
            type: 'application/json'
          }))
        }
      } else {
        const headers = { 'x-log-apiversion': '0.6.0', 'x-log-bodyrawsize': '2048' }
        this.$post(url, opts, { headers })
          .then(x => console.log(`[SLS Report] ${url} ${opts}`, x))
      }
    }
  }
}

export default plugin
